<template>
  <div class="card" :class="isHidden ? 'entity-hidden' : ''">
    <div class="card-body d-flex">
      <div class="pr-3" v-if="objectData.logo_url !== null">
        <img class="img-thumbnail" :src="objectData.logo_url" alt="Company Logo" style="max-width: 100px"/>
      </div>
      <div class="flex-fill">
        <div class="d-flex align-items-center flex-fill">
          <div class="object-name">
            <i v-if="objectData.type === 'organization'" class="fas fa-building"></i>
            <i v-if="objectData.type === 'individual'" class="fas fa-user"></i>
            {{ objectData.name }}
          </div>
          <div class="object-links d-flex align-items-center ml-auto">
            <a class="p-1 mx-1" v-if="objectData.neon_id !== null" :href="'https://secure.medicalalley.org/admin/accounts/' + objectData.neon_id" target="_blank">
              NEON
            </a>
            <a class="p-1 mx-1" v-if="objectData.website_url !== null" :href="objectData.website_url" target="_blank">
              <i  class="fas fa-link"></i>
            </a>
            <a class="p-1 mx-1" v-if="objectData.linkedin_url !== null" :href="objectData.linkedin_url" target="_blank">
              <i class="fab fa-linkedin-in"></i>
            </a>
            <a class="p-1 mx-1" v-if="objectData.twitter_screen_name !== null" :href="'https://twitter.com/' + objectData.twitter_screen_name" target="_blank">
              <i  class="fab fa-twitter"></i>
            </a>
            <!-- <i class="fas fa-trash delete-button mx-1" v-if="!isHidden" style="" @click="softDeleteEntity"></i>
            <i class="fas fa-undo delete-button mx-1" v-if="isHidden" style="" @click="softDeleteEntity"></i> -->

          </div>
        </div>
        <div v-if="!isHidden">
          <div class="pt-2"></div>
          <!-- DESCRIPTION -->
          <div class="object-description" v-if="objectData.description !== null">
            <span style="font-weight: 700">ABOUT:</span> {{ objectData.description }}
          </div>
          <div class="object-description" v-if="objectData.description === null">
            <span style="font-weight: 700">NO DESCRIPTION</span>
          </div>
          <!-- TAGS -->
          <div class="pt-2"></div>
          <div class="object-tags d-flex align-items-center"  style="width: 100%">
            <span style="font-weight: 700">TAGS:&nbsp;</span>
            <list-of-tags class="flex-fill" v-bind:tag-array="objectData.tags" v-bind:id="objectData.id"></list-of-tags>
          </div>
          <div class="object-tags " v-if="objectData.tags.length === 0">
            <span style="font-weight: 700">NO TAGS</span>
          </div>
          <!-- ACTIVITIES -->
          <div class="pt-2"></div>
          <div class="object-activities" v-if="objectData.activity_count > 0">
           <div class="d-flex align-items-center">
             <span style="font-weight: 700">ACTIVITIES: {{ objectData.activity_count }}</span>
             <div class="ml-auto">
               <div class="btn btn-sm btn-dark m-1" v-if="!loadingActivities && activities === null" @click="loadActivitiesThroughNeonID" style="cursor: pointer">
                 LOAD {{ objectData.activity_count === 1 ? 'ACTIVITY' : 'ACTIVITIES' }}
               </div>
               <div class="btn btn-sm btn-dark m-1" v-if="!loadingActivities && activities !== null" @click="activities = null" style="cursor: pointer">
                 HIDE {{ objectData.activity_count === 1 ? 'ACTIVITY' : 'ACTIVITIES' }}
               </div>
               <router-link class="btn btn-sm btn-dark m-1" :to="{ name: 'Activity Creation', query: {account_ids: objectData.neon_id}}" target='_blank'>ADD ACTIVITY</router-link>
             </div>
           </div>
            <div class="d-flex justify-content-center align-items-center" v-if="loadingActivities">
              <div class="spinner-grow text-danger" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div v-if="!loadingActivities && activities !== null" class="mb-2">
              <!-- Activities will not have their own component as they will not be used elsewhere -->
              <div v-for="activity in activities" :key="activity.id">
                <div class="d-flex">
                  <div>
                    {{ activity.subject}}
                  </div>
                  <div class="ml-auto">
                    {{ activity.when_created | formatDate}}
                  </div>
                </div>
                <div style="font-weight: 300">
                  {{ activity.note }}
                </div>
                <hr/>
              </div>
            </div>
          </div>
          <div class="object-activities" v-if="objectData.activity_count === 0">
            <span style="font-weight: 700">NO ACTIVITIES</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListOfTags from './ListOfTags'
import MedicalAlleyStartsV3API from '../../api/medicalAlleyStartsV3'
export default {
  name: '',
  props: ['objectData'],
  components: {ListOfTags},
  data: function () {
    return {
      loadingActivities: false,
      activities: null,
      isHidden: false
    }
  },
  methods: {
    softDeleteEntity () {
      MedicalAlleyStartsV3API.deleteMedicalAlleyStartsV3Entity(
        this.objectData.neon_id
      ).then(response  => {
        if (response.data.success) {
          this.isHidden = !this.isHidden
        }
      })
    },
    loadActivitiesThroughNeonID () {
      this.loadingActivities = true
      MedicalAlleyStartsV3API.getMedicalAlleyStartsV3ActivitiesOfAccount(this.objectData.neon_id).then(
        response => {
          this.loadingActivities = false
          this.activities = response.data.data
        }
      )
    }
  }
}
</script>

<style scoped>
.entity-hidden {
  background: #cccccc;
  color: #444444;
}
.object-name {
  font-size: 2em;
}
.object-description {
  font-weight: 300;
}
.object-links a {
  color: #000000;
}
.object-links a:hover {
  color: #55ABBF;
}
.delete-button {
  cursor: pointer;
  color: #be1e2d;
}
.delete-button:hover {
  color: #3E597A;
}
</style>



// WEBPACK FOOTER //
// src/components/medicalAlleyStarts/SingleOrganizationInList.vue